import { mapGetters } from 'vuex'

export default {
  name: 'ModalRoot',
  data: function () {
    return {
      modalIndexToRemove: 0,
      payload: null
    }
  },
  computed: {
    ...mapGetters({
      modals: 'modal/getModals'
    }),
    isOpen() {
      return this.modals.length > 0
    },
    styleObj() {
      return this.$isRemoteClient && this.isOpen && this.$route.path != '/qr'
        ? { top: '7rem' }
        : {}
    }
  },
  methods: {
    close(payload, index, canClose = true) {
      if (canClose) {
        this.modalIndexToRemove = index
        this.payload = payload // false or true or undefinded (when nothing is passed) or truthy when passed object {}

        // animate out
        this.modals[index].isVisible = false

        // delayed close with confirm or cancel
        if (!payload) {
          setTimeout(this.cancel, 200)
        } else {
          setTimeout(this.confirm, 200)
        }
      }
    },

    confirm() {
      // callback will be executed with payload data
      this.$store.commit('modal/close', {
        index: this.modalIndexToRemove,
        data: this.payload
      })
    },

    cancel() {
      // callback will be executed WITHOUT payload data
      this.$store.commit('modal/close', { index: this.modalIndexToRemove, data: null })
    }
  }
}
